<template>
  <div>
    <el-table
      :data="table_data"
      style="width: 100%"
      border
      :show-header="false"
    >
      <el-table-column
        prop="key"
        label="Field"
        width="200"
      />
      <el-table-column>
        <template #default="{ row }">
          <div v-if="is_object(row.value)">
            <recursive-table :data="row.value" />
          </div>
          <div v-else-if="Array.isArray(row.value)">
            <el-table
              v-if="row.value.length && is_object(row.value[0])"
              :data="row.value"
              border
              size="mini"
              style="margin: 5px 0; width: 100%;"
            >
              <el-table-column
                v-for="(val, key) in row.value[0]"
                :key="key"
                :prop="key"
                :label="key"
              />
            </el-table>
            <ul
              v-else
              style="padding-left: 1em; margin: 0;"
            >
              <li
                v-for="(item, idx) in row.value"
                :key="idx"
              >
                {{ format_value(item) }}
              </li>
            </ul>
          </div>
          <div v-else>
            {{ format_value(row.value) }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'RecursiveTable',
  props: {
    data: { type: Object, required: true }
  },
  computed: {
    table_data() {
      return Object.entries(this.data).map(([key, value]) => ({ key, value }));
    }
  },
  methods: {
    is_object(value) {
      return value !== null && typeof value === 'object' && !Array.isArray(value);
    },
    format_value(value) {
      if (typeof value === 'string') {
        const match = /\/Date\((\d+)([+-]\d+)?\)\//.exec(value);
        if (match) {
          const timestamp = parseInt(match[1], 10);
          return new Date(timestamp).toLocaleString();
        }
      }
      return value;
    }
  }
};
</script>
